<template>
	<VerticalLayout>
		<ResidualsByBaseStationChart />
		<ResidualsBySatelliteChart />
	</VerticalLayout>
</template>

<script>
import VerticalLayout from '@/components/common/VerticalLayout';
import ResidualsByBaseStationChart from '@/components/stats/ResidualsByBaseStationChart.vue';
import ResidualsBySatelliteChart from '@/components/stats/ResidualsBySatelliteChart.vue';

export default {
	components: {
		VerticalLayout,
		ResidualsByBaseStationChart,
		ResidualsBySatelliteChart,
	},
}
</script>
